import React, { useEffect, useState } from 'react'
import { Box, MenuItem, Select, styled, Tab, Typography, useMediaQuery, useTheme } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Call, Email, NearMe } from '@mui/icons-material';
import faqs from '../../assets/data/faqs';



const TabStyled = styled(Tab)(({ theme }) => ({
  color: 'gray', // Default text color
  borderBottom: '2px solid transparent', // Invisible border to prevent shifting
  '&.Mui-selected': {
    color: '#211a60', // Active text color
    borderBottom: '2px solid #f50057', // Active bottom border
    fontWeight: '600',
  },
  textTransform: 'none', // Optional: keep original case
}))


function FAQs() {

  const [value, setValue] = useState('1');

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top whenever pathname changes
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  const RRFaqs = faqs.filter((faq) => faq.category === 'Report Related FAQs');
  const ODFaqs = faqs.filter((faq) => faq.category === 'Ordering and Delivery');
  const LTPOFaqs = faqs.filter((faq) => faq.category === 'License Type and Purchase Options');
  const PIFaqs = faqs.filter((faq) => faq.category === 'Payments and Invoicing');
  const PSQFaqs = faqs.filter((faq) => faq.category === 'Post-Sale Queries');

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: "space-between",
        px: { xs: 3, md: 5 },
        py: 10,
        gap: { xs: 3, md: 1 },
      }}
    >
      <Box
        sx={{
          position: { xs: 'relative', md: "sticky" },
          top: { xs: 0, md: 80 },
          mt: { xs: -5, md: 5 },
          width: { xs: '100%', md: "20%" },
          height: { xs: '20vh', md: '30vh' },
          bgcolor: "white",
          border: "2px solid #f50057",
        }}
      >
        <Typography
          sx={{
            width: "100%",
            fontSize: "1.1rem",
            fontWeight: "600",
            textAlign: "center",
            py: 0.5,
            color: "black",
            background: "radial-gradient(circle, #d7bff4 0%, #a88beb 100%)",
          }}
        >
          Contact Us
        </Typography>
        <Box
          sx={{
            height: "30%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            my: { xs: 1, md: 2 },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: '0.9rem', md: "1rem" },
              fontWeight: "700",
              color: "#f50057",
              display: "inline-flex",
              alignItems: "center",
              gap: { xs: 1, md: 2 },
            }}
          >
            <Call sx={{ fontSize: { xs: '1.1rem', md: "1.5rem" } }} /> Call Us
          </Typography>
          <Typography sx={{ fontWeight: "600", fontSize: { xs: '0.9rem', md: "1rem" } }}>+91 9637373615</Typography>
        </Box>
        <Box
          sx={{
            height: "30%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            my: { xs: 1, md: 2 },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: '0.9rem', md: "1rem" },
              fontWeight: "700",
              color: "#f50057",
              display: "inline-flex",
              alignItems: "center",
              gap: { xs: 1, md: 2 },
            }}
          >
            <Email sx={{ fontSize: { xs: '1.1rem', md: "1.5rem" } }} /> Drop Us an Email
          </Typography>
          <Typography sx={{ fontWeight: "600", fontSize: { xs: '0.9rem', md: "1rem" } }}>
            data.pi@zohomail.in
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          width: { xs: '100%', md: "75%" },
          p: { xs: 0, md: 3 },
          typography: "body",
          borderLeft: { xs: 'none', md: "1px solid grey" },
          borderTop: { xs: '1px solid grey', md: "none" },
        }}
      >
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            { isMobile ?

              // DropDown List
              <Select
                value={value}
                onChange={(e) => setValue(e.target.value)}
                fullWidth
                size="small"
                sx={{ my: 2 }}
              >
                <MenuItem value="1">Report Related</MenuItem>
                <MenuItem value="2">Ordering and Delivery</MenuItem>
                <MenuItem value="3">License Type and Purchase Options</MenuItem>
                <MenuItem value="4">Payments and Invoicing</MenuItem>
                <MenuItem value="5">Post-Sale Queries</MenuItem>
              </Select>
            
            :

              // MUi Tablist
              <TabList
                onChange={handleChange}
                indicatorColor="none"
                aria-label="lab API tabs example"
              >
                <TabStyled label="Report Related" value="1" />
                <TabStyled label="Ordering and Delivery" value="2" />
                <TabStyled label="License Type and Purchase Options" value="3" />
                <TabStyled label="Payments and Invoicing" value="4" />
                <TabStyled label="Post-Sale Queries" value="5" />
              </TabList>

            }
          </Box>

          <TabPanel value="1" sx={{ px: { xs: 0, md: 3 } }} >
            {RRFaqs.map((faq) => (
              <Box
                key={faq}
                sx={{ display: "flex", flexDirection: "column", mb: 2, width: { xs: '100%', md: '100%' } }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: '0.9rem', md: "1rem" },
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <NearMe sx={{ fontSize: "1rem" }} />
                  {faq.question}
                </Typography>
                <Typography sx={{ ml: 5, fontSize: { xs: '0.9rem', md: "1rem" } }}>{faq.answer}</Typography>
              </Box>
            ))}
          </TabPanel>

          <TabPanel value="2" sx={{ px: { xs: 0, md: 3 } }} >
            {ODFaqs.map((faq) => (
              <Box
                key={faq}
                sx={{ display: "flex", flexDirection: "column", mb: 2, width: { xs: '100%', md: '100%' } }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: '0.9rem', md: "1rem" },
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <NearMe sx={{ fontSize: "1rem" }} />
                  {faq.question}
                </Typography>
                <Typography sx={{ ml: 5, fontSize: { xs: '0.9rem', md: "1rem" } }}>{faq.answer}</Typography>
              </Box>
            ))}
          </TabPanel>

          <TabPanel value="3" sx={{ px: { xs: 0, md: 3 } }} >
            {LTPOFaqs.map((faq) => (
              <Box
                key={faq}
                sx={{ display: "flex", flexDirection: "column", mb: 2, width: { xs: '100%', md: '100%' } }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: '0.9rem', md: "1rem" },
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <NearMe sx={{ fontSize: "1rem" }} />
                  {faq.question}
                </Typography>
                <Typography sx={{ ml: 5, fontSize: { xs: '0.9rem', md: "1rem" } }}>{faq.answer}</Typography>
              </Box>
            ))}
          </TabPanel>

          <TabPanel value="4" sx={{ px: { xs: 0, md: 3 } }} >
            {PIFaqs.map((faq) => (
              <Box
                key={faq}
                sx={{ display: "flex", flexDirection: "column", mb: 2, width: { xs: '100%', md: '100%' } }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: '0.9rem', md: "1rem" },
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <NearMe sx={{ fontSize: "1rem" }} />
                  {faq.question}
                </Typography>
                <Typography sx={{ ml: 5, fontSize: { xs: '0.9rem', md: "1rem" } }}>{faq.answer}</Typography>
              </Box>
            ))}
          </TabPanel>

          <TabPanel value="5" sx={{ px: { xs: 0, md: 3 } }} >
            {PSQFaqs.map((faq) => (
              <Box
                key={faq}
                sx={{ display: "flex", flexDirection: "column", mb: 2, width: { xs: '100%', md: '100%' } }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: '0.9rem', md: "1rem" },
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <NearMe sx={{ fontSize: "1rem" }} />
                  {faq.question}
                </Typography>
                <Typography sx={{ ml: 5, fontSize: { xs: '0.9rem', md: "1rem" } }}>{faq.answer}</Typography>
              </Box>
            ))}
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
}

export default FAQs
